import { INIT, SUCCESS, LOADING, ERROR } from "../../../utils/constants";
import {
  GET_GCP_CLOUD_RUN,
  GET_GCP_CLOUD_RUN_SUCCESS,
  GET_GCP_CLOUD_RUN_ERROR,
} from "./constant";

const initialState = {
  phase: INIT,
  gcpCloudRunList: null,
  error: null,
};

export function GCPCloudRunStore(state = initialState, action) {
  switch (action.type) {
    case GET_GCP_CLOUD_RUN:
      return {
        ...state,
        phase: LOADING,
      };
    case GET_GCP_CLOUD_RUN_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        gcpCloudRunList: action.data,
        error: null,
      };
    case GET_GCP_CLOUD_RUN_ERROR:
      return { ...state, phase: ERROR, error: action.error };
    default:
      return state;
  }
}
